import type { StoreApi, UseBoundStore } from 'zustand';
import type { DataSourceControllerState } from './types';

export const createDataSourceControllerSliceSelectors = (
  store: UseBoundStore<StoreApi<DataSourceControllerState>>,
) => {
  const dataSourceSelectors = {
    useResult: (dataSourceId: string) => {
      return store((state) => state.dataSources[dataSourceId]);
    },
    useMeta: (dataSourceId: string) => {
      return store((state) => state.dataSourcesMeta[dataSourceId]);
    },
    triggered: {
      useManually: (dataSourceId: string) => {
        return store((state) => state.manuallyTriggeredDataSources[dataSourceId]);
      },
      usePreview: (dataSourceId: string) => {
        return store((state) => state.previewTriggeredDataSources[dataSourceId]);
      },
      useRun: (dataSourceId: string) => {
        return store((state) => state.runTriggeredDataSources[dataSourceId]);
      },
    },
    usePreviewResult: (dataSourceId: string) => {
      return store((state) => state.dataSourcesMeta[dataSourceId]?.previewResult);
    },
    useIntraDependencies: () => {
      return store((state) => state.dataSourceIntraDependencies);
    },
    useDependencyFlow: () => {
      return store((state) => state.dataSourceDependencyFlow);
    },
    useDependencyFlowStatus: (dataSourceId: string) => {
      return store((state) => state.dataSourceDependencyFlow[dataSourceId]?.status);
    },
  };

  return { dataSourceSelectors };
};

export const createDataSourceControllerSliceKeysSelectors = (
  store: UseBoundStore<StoreApi<DataSourceControllerState>>,
) => {
  const dataSourceKeysSelectors = {
    useDataSources: () => store((state) => state.dataSources),
    useDataSourcesMeta: () => store((state) => state.dataSourcesMeta),
    useManuallyTriggeredDataSources: () => store((state) => state.manuallyTriggeredDataSources),
    usePreviewTriggeredDataSources: () => store((state) => state.previewTriggeredDataSources),
    useRunTriggeredDataSources: () => store((state) => state.runTriggeredDataSources),
  };

  return { dataSourceKeysSelectors };
};
